export const environment = {
  production: false,
  environment: 'staging',
  eventBaseUrl: 'https://stg-event-order.sakuramobile.jp',
  siteBaseUrl: 'https://stg-longterm-order.sakuramobile.jp',
  apiBaseUrl: 'https://stg-longterm-system-be.sakuramobile.jp/api',
  ekycAppUrl: 'https://stg-ekyc-app.sakuramobile.jp',
  // TODO: longterm-order-fe(旧アプリ)への移行期間中の暫定リンク先。移行完了後に削除
  longtermOrderUrl: 'https://stg-longterm-order.sakuramobile.jp',
}
